import { ContactInfo } from 'graphql/generated';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Summary } from '../summary';
import { ContactSummaryItem } from './contact-summary-item';
import ContactsIcon from '@material-ui/icons/Contacts';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import { logAnalyticsEvent } from 'ui-services/analytics.ui-service';
import { GoogleAnaliticsEvent } from 'enum';

type ContactSummaryProps = {
    contacts: ContactInfo;
};

export const ContactSummary: React.FC<ContactSummaryProps> = ({ contacts }) => {
    const { t } = useTranslation();
    const isVisible =
        contacts.name || contacts?.emails?.some((email) => email) || contacts?.phones?.some((phone) => phone);

    return isVisible ? (
        <Summary title={t('jobDetails:contacts')}>
            {contacts.name && (
                <ContactSummaryItem
                    title={t('jobDetails:contactPerson')}
                    text={contacts.name}
                    icon={<ContactsIcon />}
                />
            )}
            {contacts.emails &&
                contacts.emails.map((email) => (
                    <ContactSummaryItem
                        key={email}
                        onClick={() => logAnalyticsEvent(GoogleAnaliticsEvent.JOB_EMAIL_CLICKED)}
                        link
                        text={email}
                        linkValue={`mailto:${email}`}
                        icon={<MailIcon />}
                    />
                ))}
            {contacts.phones &&
                contacts.phones.map((phoneNumber) => (
                    <ContactSummaryItem
                        key={phoneNumber.number}
                        onClick={() => logAnalyticsEvent(GoogleAnaliticsEvent.JOB_PHONE_CLICKED)}
                        link
                        linkValue={`tel:${phoneNumber.number}`}
                        text={phoneNumber.number as string}
                        icon={<PhoneIcon />}
                    />
                ))}
        </Summary>
    ) : null;
};
